import React, { useState } from 'react';
import ColorPicker from '@vtaits/react-color-picker';
import '@vtaits/react-color-picker/dist/index.css';
import Modal from '../Modal';
import Button from '../Button';
import { get } from 'lodash';
import Input from '../Input';
import { isEmpty } from '../../utils/lodashExtend';

const defaultColor = "#21D4A9";
const ColorPickerComponent = (props) => {
  const { onChange, field, form = {} } = props;
  const [color, setColor] = useState(get(form, field.key, defaultColor));

  const [open, setOpen] = useState(false);

  const onDrag = (color) => {
    setColor(color);
  };

  const onChangeInput = (e) => {
    setColor(e?.target?.value);
  };

  const close = () => {
    setOpen(false);
    isEmpty(color) && setColor(defaultColor);
  };
  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        style={{
          background: color,
          color: 'white'
        }}>
        {color}
      </Button>

      <Modal
        isOpen={open}
        close={close}
        style={{ width: "350px" }}
        className={"color-picker-modal"}
      >
        <ColorPicker value={color} onDrag={onDrag} />
        <Input
          value={color}
          type="text"
          onChange={onChangeInput}
          name={"color"}
          className={"color-input mb-5"}
          style={{
            textTransform: "uppercase"
          }}
        />
        <Button
          onClick={() => {
            onChange({ [field?.key]: color || defaultColor });
            setOpen(false);
          }}
          style={{
            background: color,
            color: 'white',
          }}
          disabled={isEmpty(color)}
        >
          선택
        </Button>
      </Modal>
    </>
  );
};

export default ColorPickerComponent;